<h3 class="width-masked-icon" [innerHtml]="value"></h3>
<mat-icon matSuffix (click)="onClickIcon()" *ngIf="isVisible">{{ isMasked ? 'visibility_off' : 'visibility' }}</mat-icon>
